import { render, staticRenderFns } from "./DeadCintilloAlaDetail.vue?vue&type=template&id=1e5f5d10&scoped=true"
import script from "./DeadCintilloAlaDetail.vue?vue&type=script&lang=js"
export * from "./DeadCintilloAlaDetail.vue?vue&type=script&lang=js"
import style0 from "./DeadCintilloAlaDetail.vue?vue&type=style&index=0&id=1e5f5d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5f5d10",
  null
  
)

export default component.exports